import { Component } from '@angular/core';

@Component({
    selector: 'app-no-network-dialog-body',
    templateUrl: './no-network-dialog-body.component.html',
    styleUrls: ['./no-network-dialog-body.component.scss']
})
export class NoNetworkDialogBodyComponent {}
